import React, { useState } from "react";
import $ from 'jquery';
import "./ToggleSwitch.css";

function ToggleSwitch(props) {

	const modeChange = (e) => {
		if(e.target.checked) {
			$('body').addClass('light-mode');
		} else {
			$('body').removeClass('light-mode');
		}
	}

return (
	<>
	<div className="model-wraper">
		<div className="d-flex align-items-center">
			<label className="switch">
				<input type="checkbox" onChange={(e)=>props.toggleMode ? modeChange(e) : null}/>
				<span className="slider"></span>
			</label>
			{props.toggleText? <span className="ms-3">{props.toggleText}</span> : ''}
		</div>
	</div>
	</>
);
}

export default ToggleSwitch;
